import React from "react";

function ErrorPage() {
  return (
    <>
      <section className="hero is-danger">
        <div className="hero-body">
          <p className="title">Error</p>
          <p className="subtitle">Page Not Found :(</p>
        </div>
      </section>
    </>
  );
}

export default ErrorPage;
